import React from "react";
import { LIDAR_COLUMN_COLORS } from "../../../util/Constants";

const LEGEND_ITEM_STYLE = {
    display: "flex",
    alignItems: "center",
    marginRight: "15px"
};

const COLOR_BOX_STYLE = (color) => ({
    width: "20px",
    height: "20px",
    backgroundColor: color,
    border: "1px solid black",
    marginRight: "5px"
});

const LEGEND_CONTAINER_STYLE = {
    display: "flex",
    marginBottom: "10px",
    fontSize: "12px"
};

const BinColorLegend = () => {
    return (
        <div style={LEGEND_CONTAINER_STYLE}>
            <div style={LEGEND_ITEM_STYLE}>
                <div style={COLOR_BOX_STYLE(LIDAR_COLUMN_COLORS.REGULAR)}></div>
                <span>Regular Bag/Two-Tier OV</span>
            </div>
            <div style={LEGEND_ITEM_STYLE}>
                <div style={COLOR_BOX_STYLE(LIDAR_COLUMN_COLORS.FLEX)}></div>
                <span>Flex</span>
            </div>
            <div style={LEGEND_ITEM_STYLE}>
                <div style={COLOR_BOX_STYLE(LIDAR_COLUMN_COLORS.UNIFIED_OV)}></div>
                <span>One-Tier OV</span>
            </div>
            <div style={LEGEND_ITEM_STYLE}>
                <div style={COLOR_BOX_STYLE(LIDAR_COLUMN_COLORS.ANOMALY)}></div>
                <span>No Column</span>
            </div>
        </div>
    );
};

export default BinColorLegend;



// WEBPACK FOOTER //
// ./src/components/devicemanagement/lidar/lidarTester/BinColorLegend.js